// Uvlaki theme — base scripts
document.addEventListener('DOMContentLoaded', function () {
  // Placeholder for future interactivity (mobile nav toggle, quick-view, etc.)
});
